/**
 * Created by lihanying on 2017/7/6.
 */
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import * as actions from './action'
import Level from './component/level'
import { Spin, Message } from 'antd'
import { fetchLevelList, fetchDelLevel } from '../../api/setExpirationTime'

class ClubLevel extends React.Component {
  static defaultProps = {
    clubLevelList: [],
  }
  state = {
    loading: true,
    discountList: [],
  }

  componentDidMount() {
    this.getDiscountList().then((res) => {
      this.setState({ loading: false })
    })

    // this.props.fetchLevelList().then((res) => {
    //   this.setState({ loading: false })
    // })
  }

  // 获取等级列表
  getDiscountList = async () => {
    const { data, detail, status } = await fetchLevelList()
    if (status == 1) {
      data.length > 0 &&
        data.map((item, index) => {
          item.discount = (item.discount * 10).toFixed(1)
        })
      this.setState({ discountList: data })
    } else {
      Message.error(detail)
    }
  }
  // 删除等级列表
  fetchDelLevel = async (id) => {
    const { data, detail, status } = await fetchDelLevel({
      id: id,
      originType: 3,
    })
    if (status == 1) {
      this.getDiscountList()
    } else {
      Message.error(detail)
    }
  }

  render() {
    const { clubLevelList, discountList } = this.props
    return (
      <div>
        {this.state.loading ? (
          <Spin
            tip="正在加载..."
            className="level-loading"
            style={{ textAlign: 'center' }}
          />
        ) : (
          <Level
            list={this.state.discountList}
            fetchEditLevel={this.props.editLevel}
            fetchDelLevel={this.props.fetchDelLevel}
            fetchAddLevel={this.props.fetchAddLevel}
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    clubLevelList: state.getClubLevel.clubLevelList,
  }
}
export default withRouter(connect(mapStateToProps, actions)(ClubLevel))



// WEBPACK FOOTER //
// ./src/containers/ClubLevel/index.js